export default __webpack_public_path__ + "static/media/WomenPlaceholder.7451cccc.jpg";